import * as actions from "../../../actions/chartOfAccount/edit";

const initialFinancialAccountState = {
  name: "",
  code: "",
  chartOfAccountsType: 0,
  description: ""
};

const initialState = {
  loading: false,
  item: null,
  errors: {},
  ...initialFinancialAccountState
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    case actions.CLEAR_VALUE: {
      const { item } = state;

      return {
        ...state,
        ...initialFinancialAccountState,
        item,
        name: item.name,
        code: item.code,
        description: item.description,
        chartOfAccountsType: item.chartOfAccountsType
      };
    }
    case actions.GET_CHART_OF_ACCOUNT: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.EDIT_CHART_OF_ACCOUNT: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_CHART_OF_ACCOUNT_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_CHART_OF_ACCOUNT_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.EDIT_CHART_OF_ACCOUNT_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_CHART_OF_ACCOUNT_SUCCESS: {
      return {
        ...state,
        item: payload,
        name: payload.name,
        code: payload.code,
        description: payload.description,
        chartOfAccountsType: payload.chartOfAccountsType,
        loading: false
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
